import React, { useState } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import ConditionalWrapper from 'UI/components/atoms/ConditionalWrapper';
import FPAvatar from 'UI/components/atoms/FPAvatar';
import InfoCard from 'UI/components/molecules/InfoCard';
import RowActions from 'UI/components/molecules/RowActions';

import { useStyles } from './styles';

/**
 * @param {Object} props
 * @param {FPAvatarProps} [props.avatarProps]
 * @param {string} [props.detail]
 * @param {string} [props.email]
 * @param {InfoCardProps} [props.infoCardProps]
 * @param {string} props.initials
 * @param {boolean} [props.showDetails]
 * @param {boolean} [props.showInfoCard]
 * @param {string} [props.title]
 */
const ProfileAvatar = ({
  avatarProps,
  detail,
  email,
  infoCardProps,
  initials,
  showInfoCard,
  showDetails,
  title
}) => {
  const classes = useStyles();
  const [uiState, setUiState] = useState({
    isInfoCardActive: false
  });

  const handleToggleInfoCard = active => () =>
    setUiState(prev => ({ ...prev, isInfoCardActive: active }));

  const Avatar = () => (
    <FPAvatar size="small" userEmail={email} {...avatarProps}>
      {initials}
    </FPAvatar>
  );
  const InfoCardWrapper = children => (
    <div
      aria-label="info-card-wrapper"
      className={classes.root}
      onMouseEnter={handleToggleInfoCard(true)}
      onMouseLeave={handleToggleInfoCard(false)}
    >
      {children}
      {uiState.isInfoCardActive && (
        <InfoCard
          ActionsComponent={RowActions}
          avatarProps={avatarProps}
          detail={detail}
          email={email}
          infoCardProps={infoCardProps}
          initials={initials}
          title={title}
        />
      )}
    </div>
  );

  return (
    <ConditionalWrapper condition={showInfoCard} wrapper={InfoCardWrapper}>
      {showDetails ? (
        <ListItem disableGutters>
          <ListItemAvatar classes={{ root: classes.listItemAvatar }}>
            <Avatar />
          </ListItemAvatar>
          <ListItemText aria-label="avatar-text" primary={title} secondary={detail} />
        </ListItem>
      ) : (
        <Avatar />
      )}
    </ConditionalWrapper>
  );
};

ProfileAvatar.defaultProps = {
  avatarProps: {},
  detail: '',
  email: '',
  infoCardProps: undefined,
  showDetails: false,
  showInfoCard: false,
  title: ''
};

export default ProfileAvatar;
